import React from "react"

import { FloorForm } from "widgets/floor/floor-form/FloorForm"

import { FloorOverlay } from "../floor-overlay/FloorOverlay"
import { useCopyFloorOverlayModel } from "./hooks/useCopyFloorOverlayModel"

export interface CopyFloorOverlayPayload {
  floorID: string
  projectID: string
}

export interface CopyFloorOverlayProps {
  floorID: string
  projectID: string
}

const PREFIX = "floor__copy"

export const CopyFloorOverlay = React.memo(
  ({ floorID, projectID }: CopyFloorOverlayProps) => {
    const { floorFormModel, headline, isLoading, isSubmitting, onCancel } =
      useCopyFloorOverlayModel({
        floorID,
        projectID
      })

    return (
      <FloorOverlay
        id="copy-floor-overlay"
        formID="copy-floor-form"
        headline={headline}
        prefix={PREFIX}
        floorFormModel={floorFormModel}
        submitButtonText={headline}
        isLoading={isLoading}
        isSubmitting={isSubmitting}
        onCancel={onCancel}
      >
        <FloorForm.LabelInput />
        <FloorForm.ProjectInput />
        <FloorForm.PositionInput />
        {/* <FloorForm.RoomAssignmentInput /> */}
      </FloorOverlay>
    )
  }
)

CopyFloorOverlay.displayName = "CopyFloorOverlay"

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    COPY_FLOOR_OVERLAY: CopyFloorOverlayPayload
  }
}
